import { FieldPrimaryListDto } from "@common/dto/field/list-primary-dto";

export type FieldsProps = {
  fields: Array<FieldPrimaryListDto>;
  loading: boolean;
  className?: string;
  moduleName: string;
  selection: {
    items: Array<FieldPrimaryListDto>;
    onChange: (selectedItems: Array<FieldPrimaryListDto>) => void;
    type: "multiple" | "single";
  };
  itemUniqProperty: keyof FieldPrimaryListDto;
  onDrag: (item: FieldPrimaryListDto) => void;
};

export enum FieldColumnKey {
  name = "name",
}
